import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Route, Switch } from 'react-router-dom'
import Actions from 'src/components/Explore/Actions'
import ContainerLayout1 from 'src/components/Explore/ContainerLayout1'
import InitiativeListDeprecate from 'src/components/Initiative/ListDeprecate'
import FuseExploreLayout from 'src/custom/fuse/components/ExploreLayout'
import { useOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import Edit from './Edit'
import ExploreHome from './Home'

// =======================================================
// Container Layouts
// =======================================================

const containerLayouts = [
   null,
   ContainerLayout1,
   // TODO: This is a Layout for use only for Fuse Temporarily
   // See PR: #309
   FuseExploreLayout
]

// =======================================================
// Container Component
// =======================================================

const Explore = ({ location, match }) => {
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()
   const { currentUserCanEdit, exploreContainerLayoutKey } = organization

   const defaultLayout = containerLayouts[1]
   const ContainerLayout = containerLayouts[exploreContainerLayoutKey] || defaultLayout

   return (
      <>
         <Helmet title={`Explore | ${organization.name}`} />
         <Switch>
            {currentUserCanEdit && <Route exact path={`${match.url}/edit`} component={Edit} />}
            <ContainerLayout organization={organization}>
               <Switch>
                  <Route
                     exact
                     path={match.url}
                     render={props => (
                        <>
                           <ExploreHome />
                           {currentUserCanEdit && <Actions />}
                        </>
                     )}
                  />
                  <Route
                     path={`${match.url}/:initiativeTypeSlug`}
                     render={(props) => {
                        const initiativeType = organization.initiativeTypes.find(t => (
                           t.slug === props.match.params.initiativeTypeSlug
                        ))

                        return (
                           <>
                              <View
                                 display="block"
                                 paddingBottom={theme.viewportPaddingBottom}>
                                 {initiativeType.description && (
                                    <View
                                       display="block"
                                       borderBottom="1px solid #ddd"
                                       paddingBottom="24px"
                                       marginBottom="24px[a-b] 30px[c-f]">
                                       <Text size="2[a-c] 3[d] 3.5[e-f]" lineHeight="130%">
                                          {initiativeType.description}
                                       </Text>
                                    </View>
                                 )}
                                 <InitiativeListDeprecate
                                    initiativeType={initiativeType}
                                 />
                              </View>
                              {currentUserCanEdit && <Actions />}
                           </>
                        )
                     }}
                  />
               </Switch>
            </ContainerLayout>
         </Switch>
      </>
   )
}

Explore.propTypes = {
   location: PropTypes.object.isRequired,
   match: PropTypes.object.isRequired
}

export default Explore
